/** Formatting helpers shared across the UI. */

/**
 * Formats an ISO timestamp as a locale date-time, or `—` when null.
 *
 * @param iso - ISO 8601 string or null.
 */
export function formatDateTime(iso: string | null): string {
  if (!iso) {
    return '—';
  }
  const date = new Date(iso);
  return Number.isNaN(date.getTime()) ? '—' : date.toLocaleString();
}

/**
 * Formats a byte count as a human-readable size (B/KB/MB).
 *
 * @param bytes - Number of bytes.
 */
export function formatBytes(bytes: number): string {
  if (bytes < 1024) {
    return `${bytes} B`;
  }
  if (bytes < 1024 * 1024) {
    return `${(bytes / 1024).toFixed(1)} KB`;
  }
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

/**
 * Returns a relative "time ago" label for an ISO timestamp.
 *
 * @param iso - ISO 8601 string or null.
 */
export function timeAgo(iso: string | null): string {
  if (!iso) {
    return '—';
  }
  const diffMs = Date.now() - new Date(iso).getTime();
  const minutes = Math.round(diffMs / 60_000);
  if (minutes < 1) {
    return 'just now';
  }
  if (minutes < 60) {
    return `${minutes} min ago`;
  }
  const hours = Math.round(minutes / 60);
  if (hours < 24) {
    return `${hours} h ago`;
  }
  return `${Math.round(hours / 24)} d ago`;
}
